
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/funeral-prepare/funeral-cost",
      function () {
        return require("private-next-pages/funeral-prepare/funeral-cost.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/funeral-prepare/funeral-cost"])
      });
    }
  